"use client"

import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react"

import Rep from "./Rep"
import RepTracker from "../field/RepTracker"
import { usePageAccess } from "../../wrappers/PageAccessContext"
import { type } from "../../theme/tokens"

/**
 * Rep Sales & Routing (2026-10-12, Helena — "combine the Rep Sales & Rep Routing section, all of it in one screen").
 *
 * 2026-10-16 (Helena: "why are there so many blocks … it must be easy to read and have immediate info"): ONE screen
 * that reads top-down —
 *   1. the filters + Export, and four KPI tiles (this month, last month, stores, strike rate month to date);
 *   2. the All reps table — one line per rep, sales and routing side by side (RepTracker hands its summary up
 *      through onSummary, drops its own Per rep tab when embedded);
 *   3. ONE tab set for the detail (2026-10-16 later, Helena "have it all in one"): Visits & km — the routing filters,
 *      the strike rate and ONE table, each visit line with that store's sales for the picked supplier — and Chart.
 *      (Was: Stores (every store of the picked rep / all reps), Visits & km (the routing
 *      filters, visits list and km per day — no strike-rate panel, it is the 4th tile), Chart.
 * The tabs are not lazy, so the Stores list and the chart (portals from Rep) keep their place while hidden.
 * Access per part is unchanged: Rep Sales hides for a restricted account; Rep Routing renders nothing when the server
 * does not treat the login as a routing admin (then there is no strike tile and no Visits & km tab content either).
 */
const RepHub = () => {
  const { restrictedyn } = usePageAccess()
  const navigate = useNavigate()
  const [routing, setRouting] = useState(null)
  const [chartTarget, setChartTarget] = useState(null)
  const [storeSales, setStoreSales] = useState(null) // every store's sales for the picked supplier (Rep → visit lines)
  const [tab, setTab] = useState(0)
  const onRoute = useCallback((rep) => navigate(`/field/route?rep=${encodeURIComponent(rep)}`), [navigate])

  const tabStyle = { fontSize: type.size.small, fontWeight: 600 }
  return (
    <Box>
      {!restrictedyn && <Rep routing={routing} onRoute={onRoute} chartTarget={tab === 1 ? chartTarget : null} hideStores onStoreSales={setStoreSales} />}
      <Tabs variant="enclosed" colorScheme="teal" index={tab} onChange={setTab} mt={2}>
        <TabList flexWrap="wrap">
          <Tab {...tabStyle}>Visits &amp; km</Tab>
          {!restrictedyn && <Tab {...tabStyle}>Chart</Tab>}
        </TabList>
        <TabPanels>
          <TabPanel px={0}><RepTracker embedded compact onSummary={setRouting} sales={restrictedyn ? null : storeSales} /></TabPanel>
          {!restrictedyn && <TabPanel px={0}><Box ref={setChartTarget} maxW="900px" /></TabPanel>}
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default RepHub
